var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgErrorCircleIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "30px",
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "Error-circle-icon-path-1",
    cx: 12,
    cy: 12,
    r: 12
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-20.8%",
    y: "-16.7%",
    width: "141.7%",
    height: "141.7%",
    filterUnits: "objectBoundingBox",
    id: "filter-2"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 1,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowBlurOuter1",
    in2: "SourceAlpha",
    operator: "out",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.1 0",
    type: "matrix",
    in: "shadowBlurOuter1",
    result: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 1,
    in: "SourceAlpha",
    result: "shadowOffsetOuter2"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    in: "shadowOffsetOuter2",
    result: "shadowBlurOuter2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowBlurOuter2",
    in2: "SourceAlpha",
    operator: "out",
    result: "shadowBlurOuter2"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.2 0",
    type: "matrix",
    in: "shadowBlurOuter2",
    result: "shadowMatrixOuter2"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter2"
  }))), /*#__PURE__*/React.createElement("polygon", {
    id: "Error-circle-icon-path-3",
    points: "0 6.25e-06 4.99999375 6.25e-06 4.99999375 16 0 16"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Error-circle-icon-Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Add/Remove-Product",
    transform: "translate(-243.000000, -652.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gen-Card-ERROR",
    transform: "translate(246.000000, 654.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon---product-error"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Error-circle-icon-Oval-"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-2)",
    xlinkHref: "#Error-circle-icon-path-1"
  }), /*#__PURE__*/React.createElement("circle", {
    stroke: "#FFFFFF",
    strokeWidth: 1,
    strokeLinejoin: "square",
    fill: "#B41F23",
    fillRule: "evenodd",
    cx: 12,
    cy: 12,
    r: 11.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "Error-circle-icon-Group-3",
    transform: "translate(9.500000, 4.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "Error-circle-icon-mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Error-circle-icon-path-3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Error-circle-icon-Clip-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.28936875,0.787475 L0.71436875,9.287475 C0.7343375,9.6866 1.063775,10.0000062 1.46343125,10.0000062 L3.53655625,10.0000062 C3.9362125,10.0000062 4.26565,9.6866 4.28561875,9.287475 L4.71061875,0.787475 C4.732025,0.35906875 4.39049375,6.25e-06 3.96155625,6.25e-06 L1.03843125,6.25e-06 C0.60949375,6.25e-06 0.2679625,0.35906875 0.28936875,0.787475 M4.99999375,13.5000062 C4.99999375,14.8785062 3.878525,16.0000062 2.49999375,16.0000062 C1.12149375,16.0000062 -6.25e-06,14.8785062 -6.25e-06,13.5000062 C-6.25e-06,12.121475 1.12149375,11.0000062 2.49999375,11.0000062 C3.878525,11.0000062 4.99999375,12.121475 4.99999375,13.5000062",
    id: "Fill-1",
    fill: "#FFFFFF",
    mask: "url(#Error-circle-icon-mask-4)"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorCircleIcon);
export default __webpack_public_path__ + "static/media/ErrorCircleIcon.2d5a4be1.svg";
export { ForwardRef as ReactComponent };